import { styled } from "@mui/material/styles";

export const Divider = styled("hr")(() => ({
  margin: "auto",
  backgroundColor: "#E2E8F0",
  width: "100%",
}));

export const IsoText = styled("span")(() => ({
  color: "#98A2B3",
  fontFamily: "Manrope",
  fontSize: "15px",
  fontStyle: "normal",
  fontWeight: 600,
  letterSpacing: "0.75px",
  marginLeft: "8px",
}));

export const StausChip = styled("div", {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>(({ active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "64px",
  borderRadius: "100px",
  mixBlendMode: "multiply",
  backgroundColor: active ? "#ECFDF3" : "#FEF3F2",
  height: "24px",
}));

export const StatusChipText = styled("span", {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active?: boolean }>(({ active }) => ({
  color: active ? "#039855" : "#D92D20",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));
